export default __webpack_public_path__ + "static/media/noResultsNews.ae1fea11.svg";